import React from "react";
import { AlertCircle } from "lucide-react";

const CustomAlert = (props) => {
  return (
    <div
      className="basket_error_alert font_md warning_color"
      role="alert"
      data-testid="basket-validation-alert"
    >
      <span className="basket_error_alert_icon" aria-hidden="true">
        <AlertCircle size={24} />
      </span>
      <span className="basket_error_alert_message">
      {props.text}
      </span>
    </div>
  );
};
export default CustomAlert;
